export const QUOTE_PART_VIEWER_ROUTE_PREFIX = '/quotes/viewer';

export const PART_DESCRIPTOR_SUGGESTION_MAP = {
  partNumber: 'part_number',
  revision: 'revision',
  description: 'description',
} as const;

export const PART_DESCRIPTOR_LABEL_MAP = {
  partNumber: 'Part Number',
  revision: 'Revision',
  description: 'Description',
} as const;

export const PART_DESCRIPTOR_TOOLTIP_MAP = {
  partNumber: 'part number',
  revision: 'revision',
  description: 'part description',
} as const;
